import styled from 'styled-components';

const GlobalUpsellingCarouselStyles = styled.div`
.slick-next{
display: none!important;
}
.slick-prev {
  display: none!important;
}
.slick-slider.slick-initialized {
    margin: 0px;
  }
.sectionBox{
  background:none;
}
.sectionBox > div {
  &::before{
    background: none ;
  }
}
 .container_dynamic{
    background-color:#F4FAF4;
    .text{
        font-size:18px;
        font-weight:700;
        padding-top:24px;
        padding-left:24px;
        padding-bottom:14px;
    }
    .titleContainer{
        display:flex;
        justify-content: space-between;
    }
    .view{
        color:${(props) => props.theme.green.darkGreen};
        padding-top:29px;
        padding-right:23px;
        >a{
            text-decoration:none;
            color:${(props) => props.theme.green.darkGreen};
            font-weight: 700;
            font-size: 16px;
        }
    }
    .plp-banner{
      padding-left:10px;
      margin-top: ${(props) => (!props?.isViewAll && !props?.isTitle ? '25px' : '24px')} !important; 
      margin-bottom: ${(props) => (!props?.isViewAll && !props?.isTitle ? '-24px' : '0px')};
      @media(max-width:390px){
        padding-left:0px;
        margin-top: 3px;

      }
        position: relative ;
        top: ${(props) => (!props?.isViewAll && !props?.isTitle ? '-40px' : '-20px')};
        padding-right:0px ;
        .box {
          cursor: pointer;
          height: 104px;
          & > div {
            > img {
              width: 755px !important ;
              padding-right: 14px ;
              border-radius: 0px ;
              min-height: 0px ;
            }
          }
        }
        
        .slick-dots {
          li {
            button {
              display: none !important;
            }
            &.slick-active {
              button {
                display: none !important;
              }
            }
          }
        }
    }
    @media(max-width:1000px){
      .plp-banner{
        padding-left:24px;
        .container{
          padding-right:0px;
        }
        padding-top:10px;
        position: relative; 
        left: -3px;
      }
    }
    @media(max-width:920px){
      .plp-banner{
        padding-left:24px;
        .container{
          padding-right:0px;
        }
        padding-top:10px;
        position: relative; 
        left: -10px;
        .box {
          cursor: pointer;
          height: 104px;
          & > div {
            > img {
              width: 640px !important;
              padding-right: 10px ;
              border-radius: 0px ;
              min-height: 0px ;
            }
          }
        }
      }
    }
    @media(max-width:820px){
      .plp-banner{
        padding-left:24px;
        .container{
          padding-right:0px;
        }
        padding-top:10px;
        position: relative; 
        left: -10px;
        .box {
          cursor: pointer;
          height: 104px;
          & > div {
            > img {
              width: 550px !important;
              padding-right: 10px ;
              border-radius: 0px ;
              min-height: 0px ;
            }
          }
        }
      }
    }
    @media(max-width:768px){
      .plp-banner{
        padding-left:24px;
        .container{
          padding-right:0px;
        }
        padding-top:10px;
        position: relative; 
        left: -27px;
        .box {
          cursor: pointer;
          height: 104px;
          & > div {
            > img {
              width: 470px !important;
              padding-right: 10px ;
              border-radius: 0px ;
              min-height: 0px ;
            }
          }
        }
      }
    }
    @media(max-width:440px){
      .plp-banner{
        padding-left:24px;
        padding-top:0px !important;
        .container{
          padding-right:0px;
        }
        margin-top: 5px !important;
        position: relative; 
        left: -27px;
        .box {
          cursor: pointer;
          height: 104px;
          & > div {
            > img {
              width: 350px !important;
              padding-right: 10px ;
              border-radius: 0px ;
              min-height: 0px ;
            }
          }
        }
      }
    }
    @media(max-width:420px){
      .plp-banner{
        padding-left:20px;
        .container{
          padding-right:0px;
        }
        padding-top:10px;
        position: relative; 
        left: -20px;
        .box {
          cursor: pointer;
          height: 104px;
          & > div {
            > img {
              width: 340px !important;
              padding-right: 10px ;
              border-radius: 0px ;
              min-height: 0px ;
            }
          }
        }
      }
    }
    @media(max-width:380px){
      .plp-banner{
        padding-left:5px;
        .container{
          padding-right:0px;
          margin-left:21px;
        }
        padding-top:10px;
        position: relative; 
        left: -27px;
        .box {
          cursor: pointer;
          height: 104px;
          & > div {
            > img {
              width: 345px !important;
              padding-right: 10px ;
              border-radius: 0px ;
              min-height: 0px ;
            }
          }
        }
      }
    }
    @media(max-width:360px){
      .plp-banner{
        padding-left:24px;
        .container{
          padding-right:0px;
          margin-left:21px;
        }
        padding-top:10px;
        position: relative; 
        left: -50px;
        .box {
          cursor: pointer;
          height: 104px;
          & > div {
            > img {
              width: 307px !important;
              padding-right: 10px ;
              border-radius: 0px ;
              min-height: 0px ;
            }
          }
        }
      }
    }
 }
`;

export default GlobalUpsellingCarouselStyles;